import styles from "../../../styles/application/sidebar/ApplicationSidebar.module.css";
import useApplicationContext from "../useApplicationContext";
import EssayReview from "./EssayReview";
import EssayReviewV2 from "./EssayReviewV2";
import EssayGuidance from "./EssayGuidance";
import NextSteps from "./NextSteps";
import BaseButton from "../../base/BaseButton";
import DoubleChevronRightIcon from "../../../imgs/double-chevron-right-icon.png";
import useUserContext from "../../auth/useUserContext";

export default function ApplicationSidebar() {
    const { showSidebar, toggleSidebar, activeSidebarTab, updateSidebarTab } = useApplicationContext();
    const { showReportCardV2 } = useUserContext();

    const handleSwitchTab = (mainTab, subTab) => {
        updateSidebarTab(mainTab, subTab);
    };

    const sidebarBody = () => {
        if (activeSidebarTab.mainTab === "guidance") {
            return <EssayGuidance />;
        } else if (activeSidebarTab.mainTab === "review") {
            if (activeSidebarTab.subTab === "reportCard") {
                return <EssayReview />;
            } else if (activeSidebarTab.subTab === "nextSteps") {
                return <NextSteps />;
            }
        } else if (activeSidebarTab.mainTab === "reviewV2") {
            return <EssayReviewV2 />;
        }

        return null;
    };

    return (
        <div
            className={`${styles.athena_sidebar_container} ${
                showSidebar ? styles.open_sidebar : styles.closed_sidebar
            }`}
        >
            <div className={styles.sidebar_header}>
                {showSidebar && (
                    <BaseButton
                        className={`${styles.button} ${styles.close_button}`}
                        onClick={() => toggleSidebar(false)}
                    >
                        <img
                            className={styles.button_icon}
                            src={DoubleChevronRightIcon}
                            alt="button for closing athena sidebar"
                        />
                    </BaseButton>
                )}
            </div>
            <div className={styles.tabs_container}>
                <div
                    className={`${styles.tab} ${activeSidebarTab.mainTab === "guidance" && styles.active_tab}`}
                    onClick={() => handleSwitchTab("guidance", "")}
                >
                    Essay Guidance
                </div>
                {!showReportCardV2 && (
                    <div
                        className={`${styles.tab} ${activeSidebarTab.mainTab === "review" && styles.active_tab}`}
                        onClick={() => handleSwitchTab("review", "")}
                    >
                        Essay Review
                    </div>
                )}
                {showReportCardV2 && (
                    <div
                        className={`${styles.tab} ${activeSidebarTab.mainTab === "reviewV2" && styles.active_tab}`}
                        onClick={() => handleSwitchTab("reviewV2", "")}
                    >
                        Essay Review for IECs
                    </div>
                )}
            </div>
            {/* {showReportCardV2 && activeSidebarTab.mainTab === "review" && (
                <div className={styles.tabs_container}>
                    <div
                        className={`${styles.tab} ${activeSidebarTab.subTab === "reportCard" && styles.active_tab}`}
                        onClick={() => handleSwitchTab("review", "reportCard")}
                    >
                        Report Card
                    </div>
                    <div
                        className={`${styles.tab} ${activeSidebarTab.subTab === "nextSteps" && styles.active_tab}`}
                        onClick={() => handleSwitchTab("review", "nextSteps")}
                    >
                        Next Steps
                    </div>
                </div>
            )} */}
            {showSidebar && <div className={styles.sidebar_content_container}>{sidebarBody()}</div>}
        </div>
    );
}
